import { useContext } from 'react';

import type { FilterFieldLoggerContextProps } from '../contexts/FilterFieldContext.types.js';
import { FilterFieldLoggerContext } from '../contexts/FilterFieldLoggerContext.js';

/** @internal */
export function useFilterFieldLoggerContext(): FilterFieldLoggerContextProps {
  return useContext(FilterFieldLoggerContext);
}
